(() => {
  const script = document.currentScript;
  const storageKey = 'nyzzle:last-product:v1';
  const selector = 'a[data-nyzzle-continue-shopping]';

  function productPath(value) {
    if (!value) return null;
    try {
      const url = new URL(value, window.location.origin);
      const path = decodeURIComponent(url.pathname);
      if (url.origin !== window.location.origin || url.username || url.password) return null;
      if (!/^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?products\/[^/?#\\]+\/?$/i.test(path)) return null;
      return url.pathname;
    } catch (_) {
      return null;
    }
  }

  let currentProduct = productPath(script?.dataset.productUrl);
  if (currentProduct) {
    try { window.sessionStorage.setItem(storageKey, currentProduct); } catch (_) { /* Storage may be disabled. */ }
  }

  function destination() {
    let recentProduct = currentProduct;
    try { recentProduct = productPath(window.sessionStorage.getItem(storageKey)) || recentProduct; } catch (_) { /* Use the directory fallback. */ }
    let fallback = '/collections';
    try {
      const configured = new URL(script?.dataset.collectionsUrl || fallback, window.location.origin);
      if (configured.origin === window.location.origin && /^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?collections\/?$/i.test(configured.pathname)) fallback = configured.pathname;
    } catch (_) { /* Keep the safe same-store directory. */ }
    const url = new URL(recentProduct || fallback, window.location.origin);
    const theme = window.Shopify?.theme;
    const themeId = String(theme?.id || '');
    if (/^\d+$/.test(themeId) && (theme?.role === 'unpublished' || new URLSearchParams(window.location.search).get('preview_theme_id') === themeId)) {
      url.searchParams.set('preview_theme_id', themeId);
    }
    return url.pathname + url.search;
  }

  function updateLinks(root) {
    if (root.matches?.(selector)) root.setAttribute('href', destination());
    root.querySelectorAll?.(selector).forEach(link => link.setAttribute('href', destination()));
  }

  updateLinks(document);
  new MutationObserver(records => {
    records.forEach(record => record.addedNodes.forEach(node => {
      if (node.nodeType === 1) updateLinks(node);
    }));
  }).observe(document.documentElement, { childList: true, subtree: true });

  document.addEventListener('click', event => {
    const link = event.target.closest?.(selector);
    if (link) link.setAttribute('href', destination());
  }, true);
})();
